import React, { useEffect, useState } from "react";
import SubmissionItem from "./SubmissionItem";
import styles from "./Submission.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import SubmittedItem from "./SubmittedItem";
import AnetItem from "./AnetItem";
import { EmsBankFiles, SendServiceHistory } from "../../../../../api";
import toast from "react-hot-toast";
import useCommonStore from "../../../../stores/common";
import { services } from "../../../../../constants";

const ANET_FINAL_STATUSES = ["Approved", "Declined", "Cancelled", "Fraud"];

function Submission({ appData, onSuccess }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [processorFiles, setProcessorFiles] = useState([]);
  const [history, setHistory] = useState([]);
  const [servicesEnabled, setServicesEnabled] = useState([]);
  const [hasAnetApplication, setHasAnetApplication] = useState(false);
  const anetIsFinal = ANET_FINAL_STATUSES.includes(appData?.anet_application?.anet_status);

  useEffect(() => {
    let servicesEnabledTemp = [];
    if (appData?.organization?.bank_applications) {
      appData?.organization?.bank_applications?.map((value) => {
        if (services.includes(value?.label?.toLowerCase())) {
          servicesEnabledTemp.push({
            name: value?.label?.toLowerCase(),
            value: value?.label?.toLowerCase(),
          });
        }
      });
      setServicesEnabled(servicesEnabledTemp);
    }

    if (appData?.anet_application) {
      setHasAnetApplication(true);
    }
    EmsBankFiles(appData.id)
      .then((res) => {
        if (res.data) {
          setProcessorFiles(res.data);
        }
      })
      .catch((err) => {});

    SendServiceHistory(appData.id)
      .then((res) => {
        if (res.status) {
          setHistory(res.data);
        } else {
          toast.error("Something went wrong while fetching data");
        }
      })
      .catch((err) => {
        toast.error("Something went wrong while fetching data");
      });
  }, []);

  return (
    <div
      className={`${styles.submissions} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div
        className={`${styles.new_submissions} ${expandAppDetails ? styles.new_sub : ""}`}
      >
        <div className={styles.head}>
          <h6>New</h6>
          <ButtonIcon bgColor="#EDEDF4" textColor="#050506">
            Submit All
          </ButtonIcon>
        </div>

        <div className={styles.submission_list}>
          {hasAnetApplication && !anetIsFinal && <AnetItem appData={appData} onSuccess={onSuccess} />}
          
          {servicesEnabled.map((processor, index) => (
            <SubmissionItem
              key={index}
              processor={processor}
              processorFiles={processorFiles}
              appData={appData}
            />
          ))}
        </div>
      </div>

      <div className={`${styles.new_submissions}`}>
        <div className={styles.head}>
          <h6>Submitted</h6>
        </div>

        <div className={styles.submission_list}>
          {hasAnetApplication && anetIsFinal && <AnetItem appData={appData} onSuccess={onSuccess} />}
          {history.map((item, index) => (
            <SubmittedItem key={index} history={item} appData={appData} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Submission;
